import { atomWithStorage } from "jotai/utils";

export const loggedUserAtom = atomWithStorage("loggedUser", {});
